import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

export const refreshToken = createAsyncThunk(
  "user/refreshToken",
  async (sessionId, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`${API_BASE}/api/auth/refresh-token`, {
        sessionId,
      });
      console.log("refresh token response data: ", response);
      return response.data;
    } catch (err) {
      if (err.response?.data?.code === "DYN_INVALID_SESSION_ID") {
        dispatch(logOut()).then(() => {
          window.location.href = "/signin?returnUrl=/";
        });
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const logIn = createAsyncThunk(
  "user/logIn",
  async (credentials, { rejectWithValue, dispatch }) => {
    try {
      let response;
      if (credentials) {
        response = await api.post(`${API_BASE}/api/auth/sign-in`, credentials);
        // console.log('credential login response data: ', response);
      } else {
        const sessionId = localStorage.getItem("session_id");
        dispatch(refreshToken(sessionId));
        response = await api.get(`${API_BASE}/api/user`);
      }

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
  {
    condition: (credentials) => {
      return !!(localStorage.getItem("session_id") || credentials);
    },
  }
);

export const profileUpdate = createAsyncThunk(
  "user/profileUpdate",
  async (userInfo, { rejectWithValue }) => {
    try {
      const response = await api.post(`${API_BASE}/api/user/profile`, userInfo);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const initialState = {
  info: null,
  isAuthenticated: false,
  isAdmin: false,
  authRequestStatus: "IDLE", // 'IDLE' | 'PENDING' | 'FULLFILLED' | 'REJECT'
  status: "IDLE", // 'IDLE' | 'PENDING' | 'FULLFILLED' | 'REJECT'
  error: null,
  // userAccessRestrictions: [],
  unReadMessage: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logInSuccess(state, action) {
      state.status = "FULFILLED";
      state.error = null;
      state.info = action.payload?.user;
      state.isAuthenticated = true;
      state.isAdmin = action.payload?.user?.userType === 5;
      // state.userAccessRestrictions = action.payload.data.userAccessRestrictions;
      console.log("====action payload data: ", action.payload);
      if (action.payload.token) {
        localStorage.setItem("AUTH_TOKEN", action.payload.token);
        localStorage.setItem("session_id", action.payload.sessionId);
        localStorage.setItem("last_refresh_time", new Date());
      }
      if (action.payload.user?.userId) {
        localStorage.setItem("user_id", action.payload.user.userId);
      }
    },
    logOut() {
      localStorage.removeItem("user_id");
      localStorage.removeItem("AUTH_TOKEN");
      localStorage.removeItem("session_id");
      localStorage.removeItem("last_refresh_time");
      // todo: remove favorites
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logIn.pending, (state) => {
        state.status = "PENDING";
        state.authRequestStatus = "PENDING";
        state.error = null;
      })
      .addCase(logIn.fulfilled, (state, action) => {
        state.status = "FULFILLED";
        state.authRequestStatus = "FULFILLED";
        state.error = null;
        state.info = action.payload.user;
        // state.userAccessRestrictions = action.payload.data.userAccessRestrictions;
        state.isAuthenticated = true;
        state.isAdmin = action.payload?.user?.userType === 5;
        if (action.payload.token) {
          localStorage.setItem("AUTH_TOKEN", action.payload.token);
          localStorage.setItem("session_id", action.payload.sessionId);
          localStorage.setItem("last_refresh_time", new Date());
        }
      })
      .addCase(logIn.rejected, (state, action) => {
        state.status = "REJECTED";
        state.authRequestStatus = "REJECTED";
        state.error = action.payload;
      })
      .addCase(refreshToken.pending, (state) => {
        state.status = "PENDING";
        state.error = null;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.status = "FULFILLED";
        state.error = null;
        localStorage.setItem("AUTH_TOKEN", action.payload.token);
        localStorage.setItem("session_id", action.payload.sessionId);
        localStorage.setItem("last_refresh_time", new Date());
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.status = "REJECTED";
        state.error = action.payload;
        // localStorage.removeItem('user_id');
        // localStorage.removeItem('AUTH_TOKEN');
        // localStorage.removeItem('session_id');
        // localStorage.removeItem('last_refresh_time');
      })
      .addCase(profileUpdate.pending, (state) => {
        state.status = "PENDING";
        state.error = null;
      })
      .addCase(profileUpdate.fulfilled, (state, action) => {
        state.status = "FULFILLED";
        state.error = null;
        state.info = action.payload;
      })
      .addCase(profileUpdate.rejected, (state, action) => {
        state.status = "REJECTED";
        state.error = action.payload;
      });
  },
});

export const { logInSuccess, logOut } = userSlice.actions;

export default userSlice.reducer;
